import React from "react";
import arsenalPhone from "./images/5_arsenal/arsenal_phone.png";
import { TITLE_FONT_SIZE, TEXT_FONT_SIZE } from "./const.js";

const Arsenal = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyItems: "center",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", flex: 1 }}>
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <img
            style={{ width: "80%" }}
            src={arsenalPhone}
            alt={"Arsenal photo"}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          color: "black",
          paddingLeft: 10,
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
            textAlign: "left",
            marginBottom: 10,
            fontSize: TITLE_FONT_SIZE,
            marginRight: "20%",
          }}
        >
          TOURNAMENT PREP HAS NEVER BEEN EASIER
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            textAlign: "left",
            marginBottom: 30,
            maxWidth: "70%",
            fontSize: TEXT_FONT_SIZE,
            marginRight: "20%",
          }}
        >
          We know it can be hard to keep track of all of your equipment. Now you
          can add all the Storm Balls in your tournament arsenal and visualize
          what is in your bag any time you want. As your arsenal evolves, you
          can keep your collection in your records on in our “basement tab” so
          you never forget your favorites. This will become a very handy tool
          for every level of play.
        </div>
      </div>
    </div>
  );
};

export default Arsenal;
